import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Alert from 'react-bootstrap/Alert';
import { connect } from 'react-redux';
import { arrayCols, filter, pipe, isObjectEmpty, toArray, arrayToObject } from '../../Utils';
import Button from 'react-bootstrap/Button';

const ProgramRow = ({data, componentState, ...rest}) => {
    const onChangeHandler = (e) =>{
        if(e.target.checked){
            let checkedPrograms = componentState.checkedState+','+e.target.name;
            if(checkedPrograms.startsWith(','))
                checkedPrograms = checkedPrograms.substr(1);
            componentState.setCheckedState(checkedPrograms);
        }
        else{ // delete the name of the program from the favs list
            componentState.setCheckedState(
                componentState.checkedState.split(',')
                .filter((el) => el !== e.target.name)
                .reduce((acc,el)=>{acc=acc+','+el; return acc;},'')
                .replace(/^,/, '') // remove first character if it's a comma
            );
        }
    };
    const isChecked = (id)=>{
        let checkedArray = componentState.checkedState.split(',');
        if(checkedArray.indexOf(id) > -1){
            return true;
        }
        return false;
    };
    return(  
    <Row>
        <Col xs='12'>
            <input
                type="checkbox"
                id = {data.id}
                name={data.id}
                {...rest}
                onChange={onChangeHandler}
                checked = {isChecked(data.id)}
            />
            &nbsp;&nbsp;
            {data.title}
        </Col> 
    </Row>);
};

ProgramRow.propTypes = {
    data: PropTypes.object
};

const FavsComp = ({rawPrograms, database, pageState}) => {

    const [checkedState, setCheckedState] = useState(pageState.classFavs);
    const [isSaving, setSaving] = useState(false);
    const [ownProgramsData, setOwnProgramsData] = useState({});
    useEffect (()=>{setCheckedState(pageState.classFavs);},[pageState.classFavs]);
    const componentState = {
        checkedState, setCheckedState,
        classFavs: pageState.classFavs
    };
    
    const findArray = (category) => 
        pipe(
            filter((e) => e.categ === category),
            arrayCols(3)
        )(rawPrograms.programs);

    const saveFavs = () =>{
        let query = {
            params:`${pageState.classID}~${checkedState}`,
            func:'saveClassFavs'   
        };
        pageState.classes.data[pageState.classID].Favorites = checkedState; 
        pageState.classFavs = checkedState;
        setSaving(true);
        pageState.request(query); 
    };

    useEffect(() => {
        if(!isObjectEmpty(ownProgramsData)) return; 
        setOwnProgramsData(arrayToObject(toArray(database['getAllPrograms'].data),'NAME'));
    });

    useEffect(()=>{
        if(database['saveClassFavs'] && database['saveClassFavs'].isLoaded && isSaving){
            window.alert('saved');
            setSaving(false);
        }
    },[database['saveClassFavs']]);

    const doesntOwnProgram=(programRec)=>{
        if(ownProgramsData[programRec.id])
            return false;
        return true;
    };

    return(<>
        <br/>
        <Alert variant={'primary'}>
            <h4> Choose Programs </h4>
            <p> Choose the programs that this classes students will use. Your students will only see the programs that you have selected. If no programs have been selected, then your students will see everything. </p>    
        </Alert>

        {rawPrograms.categories.map((category, categKey) => <span key={categKey}>
            <Row style={{fontWeight:'bold', backgroundColor:'lightBlue', padding:'5px'}} > <Col xs='12'>{category}</Col></Row>
            <Row>
                { findArray(category).map((colPorgrams, colKey) => 
                    <Col key={colKey} xs='4'>
                        {colPorgrams.map((programRec, progKey) => <ProgramRow key={progKey} componentState={componentState} data={programRec} disabled={doesntOwnProgram(programRec)} />)}
                    </Col>
                )}
            </Row>
        </span>)}  

        <br/><Button onClick={saveFavs} variant='success'>Save</Button>    
    </>);
};

FavsComp.propTypes = {
    rawPrograms: PropTypes.object
};

const mapStateToProps = state => {
    return {
        database: state.genericReducer,
        rawPrograms: state.rawProgramReducer
   };
};
  
export default connect(mapStateToProps)(FavsComp);